module.exports = __webpack_public_path__ + "img/drone.edbf4361.png";